#import "./TrainingCourseAdminFields.graphql"

mutation UpdateTrainingCourse(
  $courseId: ID!
  $courseInput: TrainingCourseInput!
) {
  updateTrainingCourse(
    input: { courseId: $courseId, courseInput: $courseInput }
  ) {
    trainingCourse {
      ...TrainingCourseAdminFields
    }
  }
}
